<template>
  <el-dialog
    title="邀请供应商详情"
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    class="dialog accept-invitation-dialog"
    width="700px"
  >
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="供应商信息" />
        </div>
        <div class="section-content">
          <el-form label-width="120px" class="detail-form">
            <el-form-item label="供应商名称：">
              <span>{{ detailInfo.supplierName }}</span>
            </el-form-item>
            <el-form-item label="联系人：">
              <span>{{ detailInfo.contactUserName }}</span>
            </el-form-item>
            <el-form-item label="联系方式：">
              <span>{{ detailInfo.contactUserPhone }}</span>
            </el-form-item>
            <el-form-item label="邮箱：">
              <span>{{ detailInfo.contactUserEmail }}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div v-if="comboCompanyList.length" class="section">
        <div class="section-title">
          <base-section-title title="联合体其他成员" />
        </div>
        <div class="section-content">
          <el-form label-width="120px" class="detail-form">
            <el-form-item v-for="item in comboCompanyList" :key="item" label="企业名称：">
              <span>{{ item }}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'

export default {

  components: {
    BaseSectionTitle
  },

  data() {
    return {
      showDialog: false,
      detailInfo: {},
      comboCompanyList: [],
    }
  },
  methods: {
    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.showDialog = false
      this.comboCompanyList = []
    },

    /**
     * 打开弹窗
     */
    open(data = {}) {
      this.showDialog = true
      this.detailInfo = data || {}
      this.comboCompanyList = data.signUpCombos ? data.signUpCombos.split(',') : []
    }
  }
}
</script>